export const LeftToRightIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path d="M11.5 1.5H12.25C12.6656 1.5 13 1.16563 13 0.75C13 0.334375 12.6656 0 12.25 0H9H8.25H7.25H6.5C4.56562 0 3 1.56562 3 3.5C3 5.43438 4.56562 7 6.5 7H7.5V9.25C7.5 9.66563 8.25 10 8.25 10C8.25 10 9 9.66563 9 9.25V7V6.25V1.5H10V9.25C10 9.66563 10.3344 10 10.75 10C11.1656 10 11.5 9.66563 11.5 9.25V1.5ZM7.5 1.5V5.5H6.5C5.39688 5.5 4.5 4.60312 4.5 3.5C4.5 2.39688 5.39688 1.5 6.5 1.5H7.25H7.5Z" />
    <path d="M10.2469 11.3064C9.9375 11.0283 9.9125 10.5564 10.1906 10.247C10.4687 9.93767 10.9406 9.91267 11.25 10.1908L13.75 12.4408C13.9094 12.5845 14 12.7877 14 13.0002C14 13.2127 13.9094 13.4158 13.7531 13.5564L11.2531 15.8064C10.9437 16.0845 10.4719 16.0595 10.1937 15.7502C9.91562 15.4408 9.94063 14.9689 10.25 14.6908L11.2969 13.7502H2.75C2.33437 13.7502 2 13.4158 2 13.0002C2 12.5845 2.33437 12.2502 2.75 12.2502H11.2969L10.25 11.3064H10.2469Z" />
  </svg>
);
